export const GET_ROLES = 'providers/workforce/Roles/GET_ROLES';

export const DELETE_ROLE = 'providers/workforce/Roles/DELETE_ROLE';

export const DUPLICATE_ROLE = 'providers/workforce/Roles/DUPLICATE_ROLE';

export const GET_PERMISSIONS_BY_ROLES = 'providers/workforce/Roles/GET_PERMISSIONS_BY_ROLES';
